import { useFormContext } from "react-hook-form"
import useUserEventSideSheet from "@/modules/calendar/stores/use-user-event-side-sheet"
import getEventCategoryInfo from "@/modules/calendar/utils/get-event-category-info"

export default function EventTitle() {
  const { isDetails } = useUserEventSideSheet()
  const { watch, register, formState } = useFormContext()
  const errors = formState.errors

  return (
    <div className="mb-2 mt-2 flex w-full items-start justify-start gap-2">
      <span>{getEventCategoryInfo(watch("category")).icon}</span>

      <div className="flex w-full flex-col gap-2">
        <input
          {...register("title", { required: true })}
          disabled={isDetails}
          placeholder="Agregar título..."
          className="truncate bg-transparent text-xl font-bold outline-none"
          {...(isDetails && { title: watch("title") })}
        />
        {errors.title && (
          <span className="block w-full text-xs text-red-500">Campo obligatorio.</span>
        )}
      </div>
    </div>
  )
}
